import React from "react";
import { TableDriving } from "../../components";

const DrivingSchool = () => {
  return (
    <div className="m-2 md:m-8 pt-[80px] sm:pt-0 p-2 md:p-6 bg-white rounded-3xl">
      <p className="text-2xl mb-4 pl-3 font-bold">Autoshkollat</p>
      <TableDriving />
    </div>
  );
};

export default DrivingSchool;
